import { jsxs as _jsxs } from "react/jsx-runtime";
import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable react-hooks/rules-of-hooks */
import * as React from "react";
import AdaptiveTooltip from "~components/adaptive-tooltip";
import prismTheme from "./prism-theme";
import { Box, Code, Divider, Heading, Icon, IconButton, Img, Link, ListItem, OrderedList, Stack, Text, UnorderedList, useClipboard, useColorModeValue } from "@chakra-ui/react";
import { FaCheck, FaCopy } from "react-icons/fa";
import { PrismAsync as SyntaxHighlighter } from "react-syntax-highlighter";

function wrapLinkId(id, children) {
  if (id) {
    return /*#__PURE__*/_jsx(Link, {
      href: "#".concat(id),
      children: children
    });
  }

  return children;
}

export var baseComponents = {
  a: function a(_ref) {
    var node = _ref.node,
        rest = _objectWithoutProperties(_ref, ["node"]);

    var href = rest.href;
    var variant = useColorModeValue("light", "dark");
    return /*#__PURE__*/_jsx(Link, _objectSpread({
      isExternal: !href.startsWith("#"),
      variant: variant
    }, rest));
  },
  p: function p(_ref2) {
    var node = _ref2.node,
        rest = _objectWithoutProperties(_ref2, ["node"]);

    return /*#__PURE__*/_jsx(Text, _objectSpread({
      as: "div"
    }, rest));
  }
};
export var postComponents = _objectSpread(_objectSpread({}, baseComponents), {}, {
  p: function p(_ref3) {
    var node = _ref3.node,
        rest = _objectWithoutProperties(_ref3, ["node"]);

    return /*#__PURE__*/_jsx(Text, _objectSpread({
      as: "div",
      fontSize: ["sm", "md"]
    }, rest));
  },
  blockquote: function blockquote(_ref4) {
    var node = _ref4.node,
        rest = _objectWithoutProperties(_ref4, ["node"]);

    return /*#__PURE__*/_jsx(Box, _objectSpread({
      borderLeftColor: "whiteAlpha.400",
      borderLeftWidth: 2,
      color: "whiteAlpha.700",
      fontSize: ["sm", "md"],
      pl: 4,
      py: 2
    }, rest));
  },
  code: function code(_ref5) {
    var node = _ref5.node,
        inline = _ref5.inline,
        className = _ref5.className,
        children = _ref5.children,
        rest = _objectWithoutProperties(_ref5, ["node", "inline", "className", "children"]);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    var source = React.useMemo(function () {
      return String(children).replace(/\n$/, "");
    }, [children]); // eslint-disable-next-line react-hooks/rules-of-hooks

    var _useClipboard = useClipboard(source),
        hasCopied = _useClipboard.hasCopied,
        onCopy = _useClipboard.onCopy;

    var match = /language-(\w+)/.exec(className !== null && className !== void 0 ? className : "");
    return !inline && match ? /*#__PURE__*/_jsxs(Box, {
      fontSize: ["xs", "sm"],
      pos: "relative",
      children: [/*#__PURE__*/_jsx(AdaptiveTooltip, {
        closeOnClick: false,
        hasArrow: true,
        label: hasCopied ? "Snippet copied!" : "Copy snippet",
        placement: "left",
        children: /*#__PURE__*/_jsx(IconButton, {
          _hover: {
            opacity: 1
          },
          "aria-label": "Copy snippet",
          icon: /*#__PURE__*/_jsx(Icon, {
            as: hasCopied ? FaCheck : FaCopy
          }),
          onClick: onCopy,
          opacity: 0.5,
          pos: "absolute",
          right: 2,
          size: "sm",
          top: 2,
          variant: "ghost"
        })
      }), /*#__PURE__*/_jsx(SyntaxHighlighter, _objectSpread(_objectSpread({
        language: match[1],
        style: prismTheme
      }, rest), {}, {
        children: source
      }))]
    }) : /*#__PURE__*/_jsx(Code, _objectSpread(_objectSpread({
      className: className,
      fontSize: ["sm", "md"]
    }, rest), {}, {
      children: source
    }));
  },
  hr: function hr(_ref6) {
    var node = _ref6.node,
        rest = _objectWithoutProperties(_ref6, ["node"]);

    return /*#__PURE__*/_jsx(Box, {
      py: 4,
      children: /*#__PURE__*/_jsx(Divider, _objectSpread({
        maxW: "lg",
        mx: "auto"
      }, rest))
    });
  },
  img: function img(_ref7) {
    var node = _ref7.node,
        rest = _objectWithoutProperties(_ref7, ["node"]);

    return /*#__PURE__*/_jsxs(Stack, {
      align: "center",
      pb: 8,
      textAlign: "center",
      children: [/*#__PURE__*/_jsx(Img, _objectSpread({
        mx: "auto"
      }, rest)), rest.alt && /*#__PURE__*/_jsx(Text, {
        color: "whiteAlpha.400",
        fontSize: "sm",
        fontStyle: "italic",
        children: rest.alt
      })]
    });
  },
  h1: function h1(_ref8) {
    var node = _ref8.node,
        id = _ref8.id,
        rest = _objectWithoutProperties(_ref8, ["node", "id"]);

    return wrapLinkId(id, /*#__PURE__*/_jsx(Heading, _objectSpread({
      size: "2xl"
    }, rest)));
  },
  h2: function h2(_ref9) {
    var node = _ref9.node,
        id = _ref9.id,
        rest = _objectWithoutProperties(_ref9, ["node", "id"]);

    return wrapLinkId(id, /*#__PURE__*/_jsx(Heading, _objectSpread({
      size: "xl"
    }, rest)));
  },
  h3: function h3(_ref10) {
    var node = _ref10.node,
        id = _ref10.id,
        rest = _objectWithoutProperties(_ref10, ["node", "id"]);

    return wrapLinkId(id, /*#__PURE__*/_jsx(Heading, _objectSpread({
      size: "lg"
    }, rest)));
  },
  h4: function h4(_ref11) {
    var node = _ref11.node,
        id = _ref11.id,
        rest = _objectWithoutProperties(_ref11, ["node", "id"]);

    return wrapLinkId(id, /*#__PURE__*/_jsx(Heading, _objectSpread({
      size: "md"
    }, rest)));
  },
  h5: function h5(_ref12) {
    var node = _ref12.node,
        id = _ref12.id,
        rest = _objectWithoutProperties(_ref12, ["node", "id"]);

    return wrapLinkId(id, /*#__PURE__*/_jsx(Heading, _objectSpread({
      size: "sm"
    }, rest)));
  },
  h6: function h6(_ref13) {
    var node = _ref13.node,
        id = _ref13.id,
        rest = _objectWithoutProperties(_ref13, ["node", "id"]);

    return wrapLinkId(id, /*#__PURE__*/_jsx(Heading, _objectSpread({
      size: "xs"
    }, rest)));
  },
  ul: function ul(_ref14) {
    var node = _ref14.node,
        ordered = _ref14.ordered,
        rest = _objectWithoutProperties(_ref14, ["node", "ordered"]);

    return /*#__PURE__*/_jsx(UnorderedList, _objectSpread({
      pl: 4
    }, rest));
  },
  ol: function ol(_ref15) {
    var node = _ref15.node,
        ordered = _ref15.ordered,
        rest = _objectWithoutProperties(_ref15, ["node", "ordered"]);

    return /*#__PURE__*/_jsx(OrderedList, _objectSpread({
      pl: 4
    }, rest));
  },
  li: function li(_ref16) {
    var node = _ref16.node,
        ordered = _ref16.ordered,
        rest = _objectWithoutProperties(_ref16, ["node", "ordered"]);

    return /*#__PURE__*/_jsx(ListItem, _objectSpread({
      fontSize: ["sm", "md"]
    }, rest));
  }
});